import React, { useState, useEffect } from 'react';
import Modal from './index';
import InputsSection from './InputsSection';
import Button from './Button';
import ModalForm from './ModalForm';
import ModalHeading from './ModalHeading';
import InputBox from './InputBox';
import styles from './EmailManagementModal.module.css';

const EmailManagementModal = ({ show, onClose, userEmails, onAddEmail, onDeleteEmail, onSetPrimary }) => {
	const [newEmail, setNewEmail] = useState('');
	const [error, setError] = useState('');

	useEffect(() => {
		if (!show) {
			setNewEmail('');
			setError('');
		}
	}, [show]);

	const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	};

	const handleAddEmail = async () => {
		const trimmedEmail = newEmail.trim();
		
		if (!trimmedEmail) {
			setError('Email address is required');
			return;
		}

		if (!validateEmail(trimmedEmail)) {
			setError('Please enter a valid email address');
			return;
		}

		try {
			await onAddEmail(trimmedEmail);
			setNewEmail('');
			setError('');
		} catch (err) {
			setError(err.message || 'Failed to add email');
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			handleAddEmail();
		}
	};

	return (
		<Modal show={show}>
			<ModalHeading heading='Manage Email Recipients' onClose={onClose} />
			<ModalForm>
				<div className={styles.container}>
					<div className={styles.section}>
						<p className={styles.sectionTitle}>Add New Email</p>
						<InputsSection>
							<InputBox
								label='Email Address'
								placeholder='user@example.com'
								value={newEmail}
								icon='email'
								onChange={(e) => {
									setNewEmail(e.target.value);
									setError('');
								}}
								onKeyPress={handleKeyPress}
								errorMessage={error}
							/>
					</InputsSection>
					<Button 
						label='Add Email' 
						onClick={handleAddEmail}
						variant='danger'
						style={{ marginTop: '1rem' }}
					/>
				</div>

					<div className={styles.section}>
						<p className={styles.sectionTitle}>Configured Email Addresses</p>
						{userEmails && userEmails.length > 0 ? (
							<div className={styles.emailList}>
								{userEmails.map((email) => (
									<div key={email.id} className={styles.emailItem}>
										<div className={styles.emailInfo}>
											<span className={styles.emailAddress}>{email.emailAddress}</span>
											{email.isPrimary && (
												<span className={styles.primaryBadge}>Primary</span>
											)}
										</div>
										<div className={styles.emailActions}>
											{!email.isPrimary && (
												<button
													className={styles.setPrimaryButton}
													onClick={() => onSetPrimary(email.id)}
													title='Set as primary'
												>
													Set Primary
												</button>
											)}
											<button
												className={styles.deleteButton}
												onClick={() => onDeleteEmail(email.id)}
												title='Delete email'
											>
												Delete
											</button>
										</div>
									</div>
								))}
							</div>
						) : (
							<p className={styles.noEmails}>
								No email addresses configured. Add one above to receive reports.
							</p>
						)}
					</div>

					<div className={styles.infoSection}>
						<p className={styles.infoText}>
							<strong>Note:</strong> Reports will be sent to all configured email addresses. 
							The primary email will be listed first in recipients.
						</p>
					</div>
				</div>
			</ModalForm>
		</Modal>
	);
};

export default EmailManagementModal;

